import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contract-conditions',
  templateUrl: './contract-conditions.component.html',
  styleUrls: ['./contract-conditions.component.scss'],
})
export class ContractConditionsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
